module.exports = __webpack_public_path__ + "static/media/icon_dollar.f0266a28.svg";